<template>
  <div class="registration-flow">
    <div class="sidebar">
      <div
        v-for="(tab, index) in tabs"
        :key="index"
        :class="['tab', { active: currentTab === index }]"
        @click="currentTab = index"
      >
        {{ tab.name }}
      </div>
    </div>
    <div class="form-area">
      <component :is="tabs[currentTab].component" @next="goToNextTab" />
    </div>
  </div>
</template>

<script>
import SimInfoForm from "@/components/buySim/SimInfoForm.vue";
import PlanInfoForm from "@/components/buySim/PlanInfoForm.vue";
import PaymentForm from "@/components/buySim/PaymentForm.vue";
import ConfirmForm from "@/components/buySim/ConfirmForm.vue";

export default {
  name: "RegistrationFlow",
  components: {
    SimInfoForm,
    PlanInfoForm,
    PaymentForm,
    ConfirmForm,
  },
  data() {
    return {
      currentTab: 0,
      tabs: [
        { name: "Sim Info", component: "SimInfoForm" },
        { name: "Plan Info", component: "PlanInfoForm" },
        { name: "Payment", component: "PaymentForm" },
        { name: "Confirm", component: "ConfirmForm" },
      ],
    };
  },
  methods: {
    goToNextTab() {
      if (this.currentTab < this.tabs.length - 1) {
        this.currentTab++;
      }
    },
  },
};
</script>

<style scoped>
.registration-flow {
  display: flex;
  height: 100vh; /* Full viewport height */
  width: 100vw;
}
.sidebar {
  width: 214px;
  background: #f8f9fa;
  padding: 1rem;
}
.tab {
  padding: 10px;
  cursor: pointer;
}
.tab.active {
  background: #007bfa;
  color: white;
  font-weight: 600;
  border-radius: 7px;
}
.form-area {
  flex: 1;
  padding: 2rem;
  background: #fff;
  overflow-y: auto;
}
</style>
